import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";

const ExportPDF = ({ disabled }: { disabled?: boolean }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      content={
        disabled ? t("buildingMaterialResources.exportNoLicenseTooltip") : ""
      }
      className={disabled ? "!cursor-not-allowed" : "cursor-pointer"}
    >
      <div className="text-gray-900 font-[400]">
        {t("dashboard.downloadBuildingCircularityReport")}
      </div>
    </Tooltip>
  );
};

export default ExportPDF;
